import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BpgHeaderComponent } from './bpg-common/header/bpg-header.component';
import { BpgFooterComponent } from './bpg-common/footer/bpg-footer.component';
import { NavigationMenuComponent } from './bpg-common/navigation-menu/navigation-menu.component';
import { BpgSiteHomePageComponent } from './bpg-common/bpg-site-home-page/bpg-site-home-page.component';
import { BpgMembershipComponent } from './bpg-membership/bpg-membership.component';
import { BpgMembershipPreviewComponent } from './bpg-membership/bpg-membership-preview/bpg-membership-preview.component';
import { BpgListComponent } from './bpg-membership/bpg-list/bpg-list.component';
import { BpgInterestComponent } from './bpg-membership/bpg-interest/bpg-interest.component';
import { BpgSkillListComponent } from './bpg-membership/bpg-skill-list/bpg-skill-list.component';
import { BpgLeadershipComponent } from './bpg-membership/bpg-leadership/bpg-leadership.component';
import { LoginComponent } from './login/login.component';
import { BpgComponent } from './bpg-self-services/bpg/bpg.component';
import { SkillsComponent } from './bpg-self-services/skills/skills.component';
import { DemographicsComponent } from './bpg-self-services/demographics/demographics.component';
import { SiteComponent } from './bpg-self-services/site/site.component';
import { AreaOfImpactComponent } from './bpg-self-services/area-of-impact/area-of-impact.component'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BpgSelfServicesComponent } from './bpg-self-services/bpg-self-services.component';
import { ConfirmationModalComponent } from './bpg-shared/confirmation-modal/confirmation-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BpgChapterHomePageComponent } from './bpg-chapter-home-page/bpg-chapter-home-page.component';
import { BpgTableComponent } from './bpg-shared/bpg-table/bpg-table.component';
import { AlertModalComponent } from './bpg-shared/alert-modal/alert-modal.component';
import { BpgDemographicsComponent } from './bpg-membership/bpg-demographics/bpg-demographics.component';
import { ChapterComponent } from './bpg-self-services/chapter/chapter.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BpgMembershipPreviewSuccessComponent } from './bpg-membership/bpg-membership-preview-success/bpg-membership-preview-success.component';
import { EventsListViewComponent } from './bpg-events/events-list-view/events-list-view.component';
import { BpgCreateAndEditEventComponent } from './bpg-events/bpg-create-and-edit-event/bpg-create-and-edit-event.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { EventsCalendarComponent } from './bpg-events/events_calendar/events-calendar/events-calendar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgxPaginationModule } from 'ngx-pagination';
import { BpgEventsComponent } from './bpg-events/bpg-events.component';
import { EventViewDetailsComponent } from './bpg-events/event-view-details/event-view-details.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { DatePipe } from '@angular/common';
import { EventsApprovalComponent } from './bpg-events/events-approval/events-approval.component';
import { AmazingTimePickerModule } from 'amazing-time-picker';
import { AdminComponent } from './bpg-admin/admin/admin.component';
import { CreateAndEditExpenseClaimComponent } from './bpg-expenses/create-and-edit-expense-claim/create-and-edit-expense-claim.component';
import { ExpenseClaimListComponent } from './bpg-expenses/expense-claim-list/expense-claim-list.component';
import { ClaimExpenseApprovalComponent } from './bpg-expenses/claim-expense-approval/claim-expense-approval.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CreateAndEditHoshinComponent } from './bpg-hoshin/create-and-edit-hoshin/create-and-edit-hoshin.component';
// import { AdalService, AdalGuard, AdalInterceptor } from 'adal-angular4';
import { HoshinListingComponent } from './bpg-hoshin/hoshin-listing/hoshin-listing.component';
import { CreateSurveyComponent } from './bpg-survey/create-survey/create-survey.component';
import { SurveyPreviewComponent } from './bpg-survey/survey-preview/survey-preview.component';
import { TakeSurveyComponent } from './bpg-survey/take-survey/take-survey.component';
import { ReportsComponent } from './reports/reports/reports.component';
import { LoginErrorComponent } from './login-error/login-error.component';
import { ViewHoshinComponent } from './bpg-hoshin/view-hoshin/view-hoshin.component';
import { LogOutComponent } from './log-out/log-out.component';
import { EditApprovalHoshinComponent } from './bpg-hoshin/edit-approval-hoshin/edit-approval-hoshin.component';
import { ChapterAdminComponent } from './bpg-admin/chapter-admin/chapter-admin.component';
import { AlertSaveModalComponent } from './bpg-shared/alert-save-modal/alert-save-modal.component';
import { Environments, environments, EnvironmentConfiguration } from './environment/services/environment.configuration';
import { BpgDiHomePageComponent } from './bpg-di-home-page/bpg-di-home-page.component';
import { DIComponent } from './bpg-self-services/d-i/d-i.component';
import { ConfigureGalleryComponent } from './bpg-self-services/configure-gallery/configure-gallery.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SafeUrlPipe } from './bpg-common/safe-url.pipe.service';
import { FileValueAccessor } from '../app/file-control-value-accessor';
import { DocumentRepositoryComponent } from './bpg-self-services/document-repository/document-repository.component';
import { ManageFolderComponent } from './bpg-self-services/manage-folder/manage-folder.component'
import { EventReportComponent } from './bpg-events/event-report/event-report.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MembershipReportComponent } from './bpg-self-services/membership-report/membership-report.component'
import { BpgSiteComponent } from './bpg-membership/bpg-site/bpg-site.component';
import { EmailManagementComponent } from './bpg-self-services/email-management/email-management.component';
import { AdditionalresourceFolderComponent } from './bpg-self-services/additionalresource-folder/additionalresource-folder.component';
import { NaacComponent } from './bpg-self-services/naac/naac.component';
import { NaacHomePageComponent } from './bpg-common/naac-home-page/naac-home-page.component';
import { NaacFolderComponent } from './bpg-self-services/naac-folder/naac-folder.component';
import { NaacAdminComponent } from './bpg-admin/naac-admin/naac-admin.component';
import { ChapterAnnouncementsComponent } from './bpg-self-services/chapter-announcements/chapter-announcements.component';
import { PushNotificationComponent } from './bpg-self-services/push-notification/push-notification.component';
import { MatDialogModule } from '@angular/material/dialog';
import { UserMembershipComponent } from './bpg-membership/user-membership/user-membership.component';
import { HoshinComponent } from './bpg-hoshin/hoshin/hoshin.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HoshinHomeComponent } from './bpg-hoshin/hoshin-home/hoshin-home.component';
import { MatMenuModule } from '@angular/material/menu';
import { MembershipGroupSignUpComponent } from './bpg-self-services/membership-group-sign-up/membership-group-sign-up.component';
import { EventsComponent } from './bpg-events/events/events.component';
import { EllipsisPipePipe } from './bpg-events/ellipsis-pipe.pipe';
import { ExpenseComponent } from './bpg-expenses/expense/expense.component';

@NgModule({
  declarations: [
    AppComponent,
    BpgHeaderComponent,
    BpgFooterComponent,
    NavigationMenuComponent,
    BpgSiteHomePageComponent,
    BpgSiteComponent,
    EventsCalendarComponent,
    BpgMembershipPreviewComponent,
    LoginComponent,
    BpgListComponent,
    BpgInterestComponent,
    BpgSkillListComponent,
    BpgLeadershipComponent,
    BpgMembershipComponent,
    BpgComponent,
    SkillsComponent,
    DemographicsComponent,
    SiteComponent,
    AreaOfImpactComponent,
    BpgSelfServicesComponent,
    ConfirmationModalComponent,
    BpgChapterHomePageComponent,
    BpgTableComponent,
    AlertModalComponent,
    BpgDemographicsComponent,
    ChapterComponent,
    BpgMembershipPreviewSuccessComponent,
    EventsListViewComponent,
    BpgCreateAndEditEventComponent,
    BpgEventsComponent,
    EventViewDetailsComponent,
    EventsApprovalComponent,
    AdminComponent,
    CreateAndEditExpenseClaimComponent,
    ExpenseClaimListComponent,
    ClaimExpenseApprovalComponent,
    CreateAndEditHoshinComponent,
    HoshinListingComponent,
    CreateSurveyComponent,
    SurveyPreviewComponent,
    TakeSurveyComponent,
    ReportsComponent,
    LoginErrorComponent,
    ViewHoshinComponent,
    LogOutComponent,
    EditApprovalHoshinComponent,
    ChapterAdminComponent,
    AlertSaveModalComponent,
    BpgDiHomePageComponent,
    DIComponent,
    ConfigureGalleryComponent,
    SafeUrlPipe,
    FileValueAccessor,
    DocumentRepositoryComponent,
    ManageFolderComponent,
    EventReportComponent,
    MembershipReportComponent,
    EmailManagementComponent,
    AdditionalresourceFolderComponent,
    NaacComponent,
    NaacHomePageComponent,
    NaacFolderComponent,
    NaacAdminComponent,
    ChapterAnnouncementsComponent,
    PushNotificationComponent,
    UserMembershipComponent,
    HoshinComponent,
    HoshinHomeComponent,
    MembershipGroupSignUpComponent,
    EventsComponent,
    EllipsisPipePipe,
    ExpenseComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    CKEditorModule,
    NgxPaginationModule,
    BrowserAnimationsModule,
    Ng4LoadingSpinnerModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    ReactiveFormsModule,
    AmazingTimePickerModule,
    NgSelectModule,
    NgbModule,
    ImageCropperModule,
    MatDialogModule,
    MatIconModule,
    MatCheckboxModule,
    MatMenuModule
  ],
  providers: [{
    provide: Environments,
    useValue: environments,
  },
    EnvironmentConfiguration, DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
